module.exports = __webpack_public_path__ + "img/res.e64ef418.png";